module.exports = __webpack_public_path__ + "static/media/125-user.300afdd6.svg";